import React from 'react'
import { DefaultTheme } from 'styled-components'
import styled from 'styled-components'

import { useAttributes } from '@hozana/dom/hooks/useAttributes'

import { BorderedDiv } from 'elements/layout/BorderedDiv'
import { Icon } from 'elements/media/Icon'
import { Link, TLinkProps } from 'elements/text/Link'
import { P } from 'elements/text/P'

import { ICON } from 'config/icons'

const StyledBorderedDiv = styled(BorderedDiv)`
  transition: box-shadow 0.3s ease-in-out;
  &:hover {
    box-shadow: 0px 1px 2px 0px #0000000f, 0px 1px 3px 0px #0000001a;
  }
`

type TBlockLinkProps = {
  icon?: ICON
  color?: keyof DefaultTheme['colors']
  bg: keyof DefaultTheme['colors']
} & TLinkProps

export const BlockLink: TFCC<TBlockLinkProps> = ({ children, icon, bg, color = 'white', ...otherProps }) => (
  <Link color={bg} w="100%" {...useAttributes()} {...otherProps}>
    <StyledBorderedDiv bg="currentColor" borderRadius="10px" p="20px 1em" align="center">
      {icon && <Icon name={icon} color={color} size="2.5em" />}
      <P color={color} bold fontSize="1em" m="5px 0 0">
        {children}
      </P>
    </StyledBorderedDiv>
  </Link>
)
